// modals/DeleteModal.js
import React from 'react';

const DeleteModal = ({ show, customer, onConfirm, onCancel }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl max-w-md w-full p-6">
                <div className="text-center mb-6">
                    <div className="text-4xl mb-3">⚠️</div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">고객 삭제 확인</h3>
                    <p className="text-gray-600 leading-relaxed">
                        정말로 <strong className="text-red-600">{customer?.name}</strong>님의<br />
                        모든 정보를 삭제하시겠습니까?<br /><br />
                        <span className="text-red-500 text-sm font-bold">
                            ⚠️ 이 작업은 되돌릴 수 없습니다!
                        </span>
                    </p>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <button
                        onClick={onCancel}
                        className="py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-bold text-lg hover:bg-gray-300"
                    >
                        취소
                    </button>
                    <button
                        onClick={onConfirm}
                        className="py-3 px-4 bg-red-500 text-white rounded-xl font-bold text-lg hover:bg-red-600"
                    >
                        삭제
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;